import { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import {
  API,
  BASE,
  I18N,
  ME,
  ROUTES,
  URL_USERS,
  V1,
  apiClient,
  checkTokenValidity,
  removeTokenCookies,
} from '@jobcost-monorepo/utils';
import { SplashScreen } from '@jobcost-monorepo/ui';
import { IUser } from '@jobcost-monorepo/crud';
import Cookies from 'js-cookie';

interface ProtectedRouteProps {
  allowedRoles: string[];
}

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
  const [user, setUser] = useState<IUser | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const lang = 'it';

  const loadUser = async () => {
    setLoading(true);
    const token = await checkTokenValidity();

    if (token) {
      const { data } = await apiClient.get<IUser>({
        url: `${BASE}${API}${V1}${URL_USERS}${ME}`,
      });
      if (data?.email) {
        setUser(data);
        if (data.hasDarkTheme) {
          document.documentElement.classList.add('dark');
        }
        lang && Cookies.set(I18N, lang.split('-')[0]);
        return setLoading(false);
      }
    }
    navigate(`/${ROUTES.SIGN_IN}`);
    removeTokenCookies();
    return setLoading(false);
  };

  useEffect(() => {
    void loadUser();
  }, []);

  if (!user || loading) return <SplashScreen />;
  if (!allowedRoles.includes(String(user?.role))) {
    return <Navigate to={`/${ROUTES.TIMESHEET_SINGLE}`} />;
  }
  return <Outlet />;
};
export default ProtectedRoute;
